import axios from "axios";

const baseUrl = process.env.REACT_APP_API_URL + "/report";

export const membersTimeLog = async (boardId, query) => {
  return axios.post(`${baseUrl}/${boardId}/time-logs`, query);
};
